import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_ERROR,
  PATH_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type


      const params = {
        accountId: action.payload.accountId,
        locale: store.getState().locale
      }
      if(action.payload.userIds && action.payload.userIds.length > 0)
        params.userIds = action.payload.userIds.join(',')

      if(action.payload.application)
        params.application = action.payload.application

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH}?${$.param(params)}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_ENTERPRISE_ACCOUNT_USER_REPORT_BATCH_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountUserReportBatchEpic.js